import React from 'react';
import styles from './LeagueAwards.module.css';

const AWARD_CATEGORIES = [
    { key: 'mostWins', title: 'Najwięcej wygranych', icon: '\u{1F3C6}', color: '#FFD700' },
    { key: 'longestWinStreak', title: 'Najdłuższa seria', icon: '\u{1F525}', color: '#FF6B35' },
    { key: 'bestGameBalance', title: 'Bilans gemów', icon: '\u{1F4CA}', color: '#388eea' },
    { key: 'highestWinPercentage', title: 'Najwyższy % wygranych', icon: '\u{1F3AF}', color: '#E74C3C' },
    { key: 'bestSetBalance', title: 'Bilans setów', icon: '\u{1F4C8}', color: '#2ECC71' },
    { key: 'mostTiebreaksWon', title: 'Wygrane tiebreaki', icon: '\u{26A1}', color: '#9B59B6' },
    { key: 'mostDominant', title: 'Najbardziej dominujący', icon: '\u{1F4AA}', color: '#E67E22' },
    { key: 'comebackKing', title: 'Król powrotów', icon: '\u{1F451}', color: '#F1C40F' },
    { key: 'warrior', title: 'Wojownik', icon: '\u{2694}\u{FE0F}', color: '#95A5A6' },
];

const MEDALS = ['\u{1F947}', '\u{1F948}', '\u{1F949}'];

const LeagueAwards = ({ awards }) => {
    if (!awards) return null;

    const visibleCategories = AWARD_CATEGORIES.filter(
        (cat) => awards[cat.key] && awards[cat.key].length > 0
    );

    if (visibleCategories.length === 0) return null;

    return (
        <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Wyróżnienia Ligowe</h3>
            <div className={styles.grid}>
                {visibleCategories.map((cat) => (
                    <div
                        key={cat.key}
                        className={styles.card}
                        style={{ borderTopColor: cat.color }}
                    >
                        <div className={styles.cardHeader}>
                            <span className={styles.cardIcon}>{cat.icon}</span>
                            <span className={styles.cardTitle}>{cat.title}</span>
                        </div>
                        <ul className={styles.entryList}>
                            {awards[cat.key].map((entry, idx) => (
                                <li key={entry.participantId} className={styles.entry}>
                                    <span className={styles.medal}>
                                        {MEDALS[idx] || ''}
                                    </span>
                                    <span className={styles.playerName}>
                                        <span>
                                            {entry.playerName}
                                            {entry.currentGroup && (
                                                <span className={styles.playerGroup}>
                                                    {' '}({entry.currentGroup})
                                                </span>
                                            )}
                                        </span>
                                        {entry.partnerName && (
                                            <span className={styles.partnerLine}>{entry.partnerName}</span>
                                        )}
                                    </span>
                                    <span className={styles.entryValue}>
                                        {entry.formattedValue}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LeagueAwards;
